import { useStore } from 'vuex';

export function useAuth() {
    const store = useStore();

    const logout = async () => {
        store.dispatch('global_loading/changeLoadingStatus', true);
        await store.dispatch('auth/logout');
        store.dispatch('global_loading/changeLoadingStatus', false);
    };

    return { logout };
}
